module.exports = __webpack_public_path__ + "img/customer_design_7@2x.12744c9.webp";